(function () {
    'use strict';

    angular
        .module('atheer')
        .filter('sessionLocalStartTime', sessionLocalStartTime);

    /* @ngInject */
    function sessionLocalStartTime($filter) {
        return function (startTime, dateFormat) {
            if (!startTime) {
                return '';
            }
            var format = dateFormat || 'MMM dd, y hh:mm a';
            var date = parseSessionInstant(startTime);
            if (isNaN(date.getTime())) {
                return '';
            }
            var formatted = $filter('date')(date, format);
            var tzLabel = getDeviceTimezoneShortName(date);
            return tzLabel ? formatted + ' ' + tzLabel : formatted;
        };

        function parseSessionInstant(value) {
            if (value instanceof Date) {
                return value;
            }
            var raw = String(value).trim();
            if (!raw) {
                return new Date(NaN);
            }
            if (/^\d+$/.test(raw)) {
                var n = Number(raw);
                return new Date(n < 1e12 ? n * 1000 : n);
            }
            // Backend UTC without Z/offset — treat as UTC (same as ibm-frontend)
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(raw)) {
                return new Date(raw + 'Z');
            }
            return new Date(raw);
        }

        function getDeviceTimezoneShortName(date) {
            try {
                if (!Intl || !Intl.DateTimeFormat) {
                    return '';
                }
                var options = { timeZoneName: 'short' };
                if (typeof Intl.DateTimeFormat.prototype.formatToParts === 'function') {
                    var parts = new Intl.DateTimeFormat(undefined, options).formatToParts(date);
                    for (var i = 0; i < parts.length; i++) {
                        if (parts[i].type === 'timeZoneName') {
                            return parts[i].value;
                        }
                    }
                }
                // Fallback for engines without formatToParts
                var localized = new Intl.DateTimeFormat(undefined, options).format(date);
                var match = localized.match(/\s([A-Z]{2,5}|GMT[+-]\d{1,2}(?::\d{2})?)$/);
                return match ? match[1] : '';
            } catch (e) {
                // Ignore and fall back to date-only display
            }
            return '';
        }
    }
})();
